import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IASEntry, IASEntryCreateParams } from "../models/shortage";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create shortage entry and return same object
 */

export const CreateShortageEntryAPI = async (params: IASEntryCreateParams): Promise<IASEntry> => {
  try {
    const response = await axios.post(getUrl(ApiType.SHORTAGE_ENTRY_CREATE), params);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.createShortageEntry, { badRequestOrder: "errorsFirst" });
  }
};
